export const officeSignUp = {
  SignUpWelcomeMessage:
    "Welcome {{- firstName}} {{- lastName}}! You have been invited to join {{- storeName}}. Activate your account to get started.",
  CreatePassword: "Create password",
  ActivateAccount: "Activate account",
  Email: "Email",
  ResendInvitation: "Enter your email to activate your provider account on Fullscript.",
  ResendInvitationSuccess:
    "If an account exists with your email address, {{email}}, we just sent you an email with instructions to activate your account.",
  ResendInvitationSubmit: "Continue with email",
} as const;
